import { Component, OnInit } from '@angular/core';
import { Constants } from '@app/constants';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { LoaderService } from '@app/core/loader.service';

@Component({
  selector: 'app-post-logout',
  templateUrl: './post-logout.component.html',
  styleUrls: ['./post-logout.component.sass'],
})
export class PostLogoutComponent implements OnInit {
  constructor(private loaderService: LoaderService, private authService: AuthenticationService) {}

  ngOnInit(): void {
    this.loaderService.showMain = false;
    this.authService.isSetLoggedOut = false;
    localStorage.removeItem('last_status');
  }

  onLogin() {
    localStorage.removeItem('isUserReloggedIn');
    localStorage.removeItem('last_status');
    window.location.href = window.location.origin;
  }
}
